import { xySortX } from 'ml-spectra-processing';
/**
 * The default ordinate of UVProbe spectra.
 */
export const absorbanceAxis = { label: 'Absorbance', units: '' };
/**
 * Builds measurement variables for UVProbe spectra.
 * @param x - wavelength values (nm).
 * @param y - ordinate values.
 * @param yAxis - label and units of the ordinate.
 * @param shouldSortX - whether to sort by increasing wavelength.
 * @returns The `x`/`y` measurement variables.
 */
export function buildVariables(x, y, yAxis = absorbanceAxis, shouldSortX = true) {
    const { x: oX, y: oY } = shouldSortX ? xySortX({ x, y }) : { x, y };
    return {
        x: {
            symbol: 'x',
            label: 'Wavelength',
            units: 'nm',
            data: oX,
            isDependent: false,
        },
        y: {
            symbol: 'y',
            label: yAxis.label,
            units: yAxis.units,
            data: oY,
            isDependent: true,
        },
    };
}
//# sourceMappingURL=buildVariables.js.map